import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { useTranslation } from 'react-i18next';

interface Props {
    orderAmount: number;
    totalAmount: number;
}

function PaymentInfo({ orderAmount, totalAmount }: Props) {
    const { t } = useTranslation('gift');
    const priceUnit = usePriceUnit();

    return (
        <Card fullWidth spacing={4}>
            <Text fontWeight='bold' size='title'>
                {t('giftOrder.paymentInfoTitle')}
            </Text>
            <Rows>
                <InfoRow fullWidth justify='space-between'>
                    <Text color={colors.textSecondary} size='body-short'>{t('giftOrder.paymentMethodLabel')}</Text>
                    <Text size='body-short'>{t('giftSent.creditCard')}</Text>
                </InfoRow>
                <InfoRow fullWidth justify='space-between'>
                    <Text color={colors.textSecondary} size='body-short'>{t('giftOrder.orderAmount')}</Text>
                    <Text size='body-short'>
                        {orderAmount.toLocaleString()}{priceUnit}
                    </Text>
                </InfoRow>
                <InfoRow fullWidth justify='space-between'>
                    <Text size='title' fontWeight='bold'>
                        {t('giftOrder.totalAmount')}
                    </Text>
                    <Text size='headline' fontWeight='bold'>
                        {totalAmount.toLocaleString()}{priceUnit}
                    </Text>
                </InfoRow>
            </Rows>
        </Card>
    );
}

const Card = styled(Column)`
    padding: var(--spacing-4);
    border: 1px solid ${colors.gray2};
    border-radius: 8px;
    background: ${colors.white};
`;

const Rows = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: var(--spacing-2);
`;

const InfoRow = styled(Row)`
    &:last-child { border-top: 1px solid ${colors.gray2}; padding-top: var(--spacing-2); }
`;

export default PaymentInfo;
